import { render, staticRenderFns } from "./ExternalPosSynchronisation.vue?vue&type=template&id=20236f06&scoped=true"
import script from "./ExternalPosSynchronisation.vue?vue&type=script&lang=js"
export * from "./ExternalPosSynchronisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20236f06",
  null
  
)

export default component.exports